<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">Price List Template Report</h1>
      <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <app-data-form [dataFields]="formFields" />
    <div class="mb-2 mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" (click)="printPassengerPriceList()">
          <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Print Passenger Price List
      </button>
      <button class="shorter-btn misc-btn" (click)="printCommercialPriceList()">
          <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Print Commercial Price List
      </button>
      <button class="shorter-btn misc-btn" (click)="printSTAREXFlyerEng()">
        <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Print STAREX-Flyer Eng
      </button>
    </div>
  </div>
</section>
